<template>
    <div>
        <v-img contain :src="image" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: 'MediaCard',
    props: {
        image: String,
    }
})
</script>